import React from "react";

type Props = {
  /** 0 → tamamen gri, 100 → tamamen turuncu */
  progress: number;
  size?: number;
};

export const StarWave = ({ progress, size = 266 }: Props) => {
  const clamped = Math.max(0, Math.min(100, progress));
  const maskHeight = (1 - clamped / 100) * 266;

  // Dalga parametreleri
  const waveAmplitude = 9; // Dalga genliği
  const waveFrequency = 1.3; // Tek dalga döngüsü

  // Dalga path'ini oluştur (üst gri alan için)
  const createWavePath = () => {
    const points: string[] = [];
    const width = 266;
    const segments = 100; // Path'i kaç parçaya böleceğiz (daha fazla = daha smooth)

    // Başlangıç noktası (sol üst)
    points.push(`M 0 0`);

    // maskHeight seviyesine kadar düz çizgi (sol kenarda)
    points.push(`L 0 ${maskHeight - waveAmplitude}`);

    // Dalga şeklini oluştur (tek dalga)
    for (let i = 0; i <= segments; i++) {
      const x = (i / segments) * width;
      const wave =
        Math.sin((x / width) * Math.PI * 2 * waveFrequency) * waveAmplitude;
      const y = maskHeight + wave;
      points.push(`L ${x} ${y}`);
    }

    // Sağ kenarda maskHeight + amplitude seviyesine kadar
    points.push(`L ${width} ${maskHeight + waveAmplitude}`);

    // Sağ üst köşeye
    points.push(`L ${width} 0`);

    // Kapalı path
    points.push(`Z`);

    return points.join(" ");
  };

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 266 266"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        {/* Gradient - üstte sarı, altta turuncu/kırmızı */}
        <linearGradient
          id="grad"
          x1="132.92"
          y1="0"
          x2="132.92"
          y2="265.84"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F9CC6C" />
          <stop offset="0.27" stopColor="#F8CB6C" />
          <stop offset="1" stopColor="#F76D6E" />
        </linearGradient>

        {/* Dinamik maske */}
        <mask id="dynamicMask">
          {/* varsayılan gizle */}
          <rect width="266" height="266" fill="black" />

          {/* ÜST GRİ ALAN (progress=0 → full, 100 → yok) - dalga şeklinde */}
          <path d={createWavePath()} fill="white" />
        </mask>
      </defs>

      {/* ALT: gradient shape (turuncu altta) */}
      <path
        d="M105.476 179.441C104.29 174.841 101.892 170.643 98.5325 167.284C95.1735 163.925 90.9755 161.527 86.3755 160.341L4.8312 139.313C3.44 138.918 2.2155 138.08 1.3436 136.927C0.471799 135.773 0 134.366 0 132.92C0 131.474 0.471799 130.067 1.3436 128.913C2.2155 127.759 3.44 126.922 4.8312 126.527L86.3755 105.486C90.9735 104.3 95.1705 101.905 98.5295 98.548C101.889 95.192 104.287 90.997 105.476 86.399L126.504 4.8547C126.895 3.458 127.732 2.2275 128.887 1.351C130.043 0.4744 131.453 0 132.904 0C134.354 0 135.763 0.4744 136.919 1.351C138.075 2.2275 138.912 3.458 139.303 4.8547L160.318 86.399C161.504 90.999 163.901 95.197 167.26 98.556C170.619 101.915 174.818 104.313 179.418 105.499L260.962 126.513C262.364 126.9 263.601 127.736 264.482 128.894C265.364 130.051 265.841 131.465 265.841 132.92C265.841 134.375 265.364 135.789 264.482 136.946C263.601 138.104 262.364 138.94 260.962 139.327L179.418 160.341C174.818 161.527 170.619 163.925 167.26 167.284C163.901 170.643 161.504 174.841 160.318 179.441L139.289 260.985C138.898 262.382 138.061 263.612 136.906 264.489C135.75 265.365 134.34 265.84 132.889 265.84C131.439 265.84 130.029 265.365 128.874 264.489C127.718 263.612 126.88 262.382 126.489 260.985L105.476 179.441Z"
        fill="url(#grad)"
      />

      {/* ÜST: gri overlay (maskeli) */}
      <path
        d="M105.476 179.441C104.29 174.841 101.892 170.643 98.5325 167.284C95.1735 163.925 90.9755 161.527 86.3755 160.341L4.8312 139.313C3.44 138.918 2.2155 138.08 1.3436 136.927C0.471799 135.773 0 134.366 0 132.92C0 131.474 0.471799 130.067 1.3436 128.913C2.2155 127.759 3.44 126.922 4.8312 126.527L86.3755 105.486C90.9735 104.3 95.1705 101.905 98.5295 98.548C101.889 95.192 104.287 90.997 105.476 86.399L126.504 4.8547C126.895 3.458 127.732 2.2275 128.887 1.351C130.043 0.4744 131.453 0 132.904 0C134.354 0 135.763 0.4744 136.919 1.351C138.075 2.2275 138.912 3.458 139.303 4.8547L160.318 86.399C161.504 90.999 163.901 95.197 167.26 98.556C170.619 101.915 174.818 104.313 179.418 105.499L260.962 126.513C262.364 126.9 263.601 127.736 264.482 128.894C265.364 130.051 265.841 131.465 265.841 132.92C265.841 134.375 265.364 135.789 264.482 136.946C263.601 138.104 262.364 138.94 260.962 139.327L179.418 160.341C174.818 161.527 170.619 163.925 167.26 167.284C163.901 170.643 161.504 174.841 160.318 179.441L139.289 260.985C138.898 262.382 138.061 263.612 136.906 264.489C135.75 265.365 134.34 265.84 132.889 265.84C131.439 265.84 130.029 265.365 128.874 264.489C127.718 263.612 126.88 262.382 126.489 260.985L105.476 179.441Z"
        fill="#F0F0F0"
        mask="url(#dynamicMask)"
      />
    </svg>
  );
};
